// extracted by mini-css-extract-plugin
module.exports = {"icon":"RssiStatus_icon__2k43q","label":"RssiStatus_label__1ABcz"};